export default __webpack_public_path__ + "static/media/709.7377576b.png";